import React, { useState } from "react";

import Modal from "../modal/Modal";
import Button from "../button/Button";
import StatusBadge from "../status-badge/StatusBadge";
import FileUploader from "../file-uploader/FileUploader";

/**
 * 本人確認バッジ（UI スタブ）。
 * 現状は `UserItem` の全呼び出し元が `hideBadges` なので描画されない。
 * 実装時は `GET /api/me` の `identity_verification` と
 * `POST /api/me/identity-files`（docs/api/me-identity-files.md）に接続する。
 * 旧 `/api/upload` への送信は Phase 3（レガシー API 撤去）で削除済み。
 */
const IdentityBadge = () => {
  const [authUser] = useState({
    file_status: "0", // 0: 未提出, 1: 審査中, 2: 本人確認済み, 3: 要更新
    user_file: "", // 本人確認書類
    user_file_name: "",
  });

  const [modalOpen, setModalOpen] = useState(false);
  const [files, setFiles] = useState([]);

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  return (
    <>
      {authUser.file_status === "0" && (
        <Button
          theme="secondary"
          variant="outlined"
          size="small"
          rightIcon="chevron_right"
          onClick={handleModalOpen}
        >
          「本人確認済み」ラベルを獲得
        </Button>
      )}
      {authUser.file_status === "1" && (
        <StatusBadge
          label="本人確認審査中"
          color="light-gray"
          leftIcon="pending"
        />
      )}
      {authUser.file_status === "3" && (
        <Button
          theme="primary"
          variant="outlined"
          size="small"
          rightIcon="chevron_right"
          onClick={handleModalOpen}
        >
          本人確認書類を更新
        </Button>
      )}
      {authUser.file_status === "2" && (
        <StatusBadge label="本人確認済み" leftIcon="editor_choice" />
      )}
      {modalOpen &&
        (authUser.file_status === "0" ? (
          <Modal
            onClose={handleModalClose}
            title="本人確認書類を提出"
            description="書類を提出して「本人確認済み」ラベルを獲得します。"
          >
            <FileUploader
              files={files}
              onChange={setFiles}
              multiple
              accept="image/*"
            />
          </Modal>
        ) : (
          <Modal
            onClose={handleModalClose}
            title="本人確認書類を更新"
            description="書類を更新して「本人確認済み」ラベルを維持します。"
          >
            {/* TODO: 提出ファイルのプレビュー */}
            <FileUploader
              files={files}
              onChange={setFiles}
              multiple
              accept="image/*"
            />
          </Modal>
        ))}
    </>
  );
};

export default IdentityBadge;
